
import { AuthForm } from './auth-form';

interface SignInFormProps {
  showHeader?: boolean;
  showFooter?: boolean;
}

export function SignInForm({ showHeader = true, showFooter = true }: SignInFormProps) {
  return <AuthForm mode="signin" showHeader={showHeader} showFooter={showFooter} />;
}
